import { createAction } from 'redux-actions'

import apiPrd from '../../services/apiPrd'
import apiPrdNew from '../../services/apiPrdNew'
import store from '../../store'
import { SET_ERROR_TO_DISPLAY } from '../../actions/types'

const LoadsService = {
  async fetchLoadsByParams(
    status,
    operationGroups,
    text,
    page,
    size,
    searchStatus = [],
    collectUF = '',
    deliveryUF = '',
    initCollectDate = '',
    endCollectDate = '',
    waitingAtLogisticOperator = false,
    trackingStatus,
    flProposalSended = false,
    flShippingNotViewed = false,
    orderBy,
    flLotAvailable = false,
  ) {
    const selectedStatus = store.getState().errors.errorsToBeDisplayed[status]

    if (selectedStatus && selectedStatus.renderError) {
      store.dispatch(
        createAction(SET_ERROR_TO_DISPLAY)({
          errorKey: status,
          errorData: {
            renderError: false,
            errorMessage: '',
          },
        }),
      )
    }

    const url = `/shipping/active/search?status=${status}&operationGroups=${operationGroups}&text=${text}&page=${page}&size=${size}`
    const urlStatus = searchStatus.length ? `&searchStatus=${searchStatus}` : ''
    const urlCollectUF = collectUF ? `&collectUF=${collectUF}` : ''
    const urlDeliveryUF = deliveryUF ? `&deliveryUF=${deliveryUF}` : ''
    const urlInitCollectDate = initCollectDate
      ? `&initCollectDate=${initCollectDate}`
      : ''
    const urlEndCollectDate = endCollectDate
      ? `&endCollectDate=${endCollectDate}`
      : ''
    const urlTrackingStatus = trackingStatus
      ? `&trackingStatus=${trackingStatus}`
      : ''
    const urlWaitingAtLogisticOperator = waitingAtLogisticOperator
      ? `&waitingAtLogisticOperator=${waitingAtLogisticOperator}`
      : ''
    const urlFlProposalSended = flProposalSended
      ? `&flProposalSended=${flProposalSended}`
      : ''
    const urlFlShippingNotViewed = flShippingNotViewed
      ? `&flShippingNotViewed=${flShippingNotViewed}`
      : ''
    const urlOrderBy = orderBy
      ? `&orderBy=${orderBy}`
      : ''
    const urlFlLotAvailable = flLotAvailable ? `&flLotAvailable=${flLotAvailable}` : ''
    try {
      const res = await apiPrdNew.get(
        `${url}${urlStatus}${urlCollectUF}${urlDeliveryUF}${urlInitCollectDate}${urlEndCollectDate}${urlWaitingAtLogisticOperator}${urlTrackingStatus}${urlFlProposalSended}${urlFlShippingNotViewed}${urlOrderBy}${urlFlLotAvailable}`,
      )

      if (res.status === 200) {
        return res.data ? res.data : {}
      }

      store.dispatch(
        createAction(SET_ERROR_TO_DISPLAY)({
          errorKey: status,
          errorData: {
            renderError: true,
            errorMessage: 'Falha ao buscar cargas.',
          },
        }),
      )
    } catch (err) {
      console.log(status, err)
    }
    return null
  },
  async fetchCountByParams(
    status,
    operationGroups,
    text,
    page,
    size,
    searchStatus = [],
    collectUF = '',
    deliveryUF = '',
    initCollectDate = '',
    endCollectDate = '',
    waitingAtLogisticOperator = false,
    trackingStatus,
    flProposalSended,
    flShippingNotViewed,
    flLotAvailable,
  ) {
    const url = `/shipping/active/count?status=${status}&operationGroups=${operationGroups}&text=${text}&page=${page}&size=${size}`
    const urlStatus = searchStatus.length ? `&searchStatus=${searchStatus}` : ''
    const urlCollectUF = collectUF ? `&collectUF=${collectUF}` : ''
    const urlDeliveryUF = deliveryUF ? `&deliveryUF=${deliveryUF}` : ''
    const urlInitCollectDate = initCollectDate
      ? `&initCollectDate=${initCollectDate}`
      : ''
    const urlEndCollectDate = endCollectDate
      ? `&endCollectDate=${endCollectDate}`
      : ''
    const urlTrackingStatus = trackingStatus
      ? `&trackingStatus=${trackingStatus}`
      : ''
    const urlWaitingAtLogisticOperator = waitingAtLogisticOperator
      ? `&waitingAtLogisticOperator=${waitingAtLogisticOperator}`
      : ''
    const urlFlProposalSended = flProposalSended
      ? `&flProposalSended=${flProposalSended}`
      : ''

    const urlFlShippingNotViewed = flShippingNotViewed
      ? `&flShippingNotViewed=${flShippingNotViewed}`
      : ''
    const urlFlLotAvailable = flLotAvailable
      ? `&flLotAvailable=${flLotAvailable}`
      : ''
    try {
      const res = await apiPrdNew.get(
        `${url}${urlStatus}${urlCollectUF}${urlDeliveryUF}${urlInitCollectDate}${urlEndCollectDate}${urlWaitingAtLogisticOperator}${urlTrackingStatus}${urlFlProposalSended}${urlFlShippingNotViewed}${urlFlLotAvailable}`,
      )
      if (res.status === 200) {
        return res.data ? res.data : 0
      }
    } catch (err) {
      console.log(status, err)
    }
    return 0
  },
  async markLoadAsDelivered(hashId, receiptPath, obs) {
    const res = await apiPrd.post(
      `shipping/${hashId}/closebytransporter?pathReceipt=${receiptPath}&observation=${obs}`,
    )
    return res.data
  },
  async requestAuctionTime(hashIds) {
    const res = await apiPrd.get(
      `/shipping/requestResidualTime?shippingIds=${hashIds.join(',')}`,
    )
    return res.data
  },
  async fetchLoadsMarketByParams(status, text, page, size) {
    const res = await apiPrd.get(
      `/shipping/active/search?status=${status}&text=${text}&page=${page}&size=${4}`,
    )
    return res.data
  },
  async fetchOperationGroups() {
    const res = await apiPrd.get('/operationgroups')
    return res.data
  },
  async downloadByParams(
    status,
    operationGroups,
    text,
    searchStatus = [],
    collectUF = '',
    deliveryUF = '',
    initCollectDate = '',
    endCollectDate = '',
    waitingAtLogisticOperator = false,
  ) {
    const url = `/shipping/active/download?status=${status}&operationGroups=${operationGroups}&text=${text}`
    const urlStatus = searchStatus.length ? `&searchStatus=${searchStatus}` : ''
    const urlCollectUF = collectUF ? `&collectUF=${collectUF}` : ''
    const urlDeliveryUF = deliveryUF ? `&deliveryUF=${deliveryUF}` : ''
    const urlInitCollectDate = initCollectDate
      ? `&initCollectDate=${initCollectDate}`
      : ''
    const urlEndCollectDate = endCollectDate
      ? `&endCollectDate=${endCollectDate}`
      : ''
    const urlWaitingAtLogisticOperator = waitingAtLogisticOperator
      ? `&waitingAtLogisticOperator=${waitingAtLogisticOperator}`
      : ''

    const res = await apiPrd.get(
      `${url}${urlStatus}${urlCollectUF}${urlDeliveryUF}${urlInitCollectDate}${urlEndCollectDate}${urlWaitingAtLogisticOperator}`,
    )
    return res.data
  },
  async fetchShippingsForGroup(operationGroupId) {
    const res = await apiPrd.get(
      `shipping/fetchForGroup?operationGroupId=${operationGroupId}`,
    )
    return res.data
  },
  async groupShippings(shippingIds) {
    const res = await apiPrd.post(`shipping/group?shippingIds=${shippingIds}`)
    return res
  },
}

export default LoadsService
